// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.5
// source: roboverse_platform_protos/statekeeping/Reported/Status.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Duration } from "../../../google/protobuf/duration";
import { PowerPolicy } from "./__Common/PowerPolicy";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Reported";

export interface Status {
  location: Status_GPSLocation | undefined;
  battery: Status_Battery | undefined;
  emergencyStopState: Status_EmergencyStopState | undefined;
  operationMode: Status_OperationMode;
  availableActions: string[];
  hasArm: boolean;
  platformVersion: string;
  powerPolicy?: PowerPolicy | undefined;
  /** The last time the robot was rebooted (UTC). */
  latestRebootTime:
    | Date
    | undefined;
  /** Whether the system recommends restarting the robot now. */
  shouldRobotRestart: boolean;
}

export enum Status_OperationMode {
  UNKNOWN = 0,
  IDLE = 1,
  ON_MISSION = 2,
  TELEOPERATION = 3,
  EXTERNAL_USE = 4,
  UNRECOGNIZED = -1,
}

export function status_OperationModeFromJSON(object: any): Status_OperationMode {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return Status_OperationMode.UNKNOWN;
    case 1:
    case "IDLE":
      return Status_OperationMode.IDLE;
    case 2:
    case "ON_MISSION":
      return Status_OperationMode.ON_MISSION;
    case 3:
    case "TELEOPERATION":
      return Status_OperationMode.TELEOPERATION;
    case 4:
    case "EXTERNAL_USE":
      return Status_OperationMode.EXTERNAL_USE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Status_OperationMode.UNRECOGNIZED;
  }
}

export function status_OperationModeToJSON(object: Status_OperationMode): string {
  switch (object) {
    case Status_OperationMode.UNKNOWN:
      return "UNKNOWN";
    case Status_OperationMode.IDLE:
      return "IDLE";
    case Status_OperationMode.ON_MISSION:
      return "ON_MISSION";
    case Status_OperationMode.TELEOPERATION:
      return "TELEOPERATION";
    case Status_OperationMode.EXTERNAL_USE:
      return "EXTERNAL_USE";
    case Status_OperationMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Status_GPSLocation {
  latitude: number;
  longitude: number;
  altitude: number;
}

export interface Status_Battery {
  chargePercentage: number;
  remainingRuntime: Duration | undefined;
  status: Status_Battery_Status;
}

export enum Status_Battery_Status {
  UNKNOWN = 0,
  CHARGING = 1,
  DISCHARGING = 2,
  NOT_CHARGING = 3,
  FULL = 4,
  UNRECOGNIZED = -1,
}

export function status_Battery_StatusFromJSON(object: any): Status_Battery_Status {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return Status_Battery_Status.UNKNOWN;
    case 1:
    case "CHARGING":
      return Status_Battery_Status.CHARGING;
    case 2:
    case "DISCHARGING":
      return Status_Battery_Status.DISCHARGING;
    case 3:
    case "NOT_CHARGING":
      return Status_Battery_Status.NOT_CHARGING;
    case 4:
    case "FULL":
      return Status_Battery_Status.FULL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Status_Battery_Status.UNRECOGNIZED;
  }
}

export function status_Battery_StatusToJSON(object: Status_Battery_Status): string {
  switch (object) {
    case Status_Battery_Status.UNKNOWN:
      return "UNKNOWN";
    case Status_Battery_Status.CHARGING:
      return "CHARGING";
    case Status_Battery_Status.DISCHARGING:
      return "DISCHARGING";
    case Status_Battery_Status.NOT_CHARGING:
      return "NOT_CHARGING";
    case Status_Battery_Status.FULL:
      return "FULL";
    case Status_Battery_Status.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** TODO confirm maps not needed */
export interface Status_EmergencyStopState {
  hardwareStopped: boolean;
  softwareStopped: boolean;
  payloadStoppped: boolean;
}

function createBaseStatus(): Status {
  return {
    location: undefined,
    battery: undefined,
    emergencyStopState: undefined,
    operationMode: 0,
    availableActions: [],
    hasArm: false,
    platformVersion: "",
    powerPolicy: undefined,
    latestRebootTime: undefined,
    shouldRobotRestart: false,
  };
}

export const Status: MessageFns<Status> = {
  encode(message: Status, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.location !== undefined) {
      Status_GPSLocation.encode(message.location, writer.uint32(10).fork()).join();
    }
    if (message.battery !== undefined) {
      Status_Battery.encode(message.battery, writer.uint32(18).fork()).join();
    }
    if (message.emergencyStopState !== undefined) {
      Status_EmergencyStopState.encode(message.emergencyStopState, writer.uint32(34).fork()).join();
    }
    if (message.operationMode !== 0) {
      writer.uint32(40).int32(message.operationMode);
    }
    for (const v of message.availableActions) {
      writer.uint32(50).string(v!);
    }
    if (message.hasArm !== false) {
      writer.uint32(72).bool(message.hasArm);
    }
    if (message.platformVersion !== "") {
      writer.uint32(82).string(message.platformVersion);
    }
    if (message.powerPolicy !== undefined) {
      PowerPolicy.encode(message.powerPolicy, writer.uint32(90).fork()).join();
    }
    if (message.latestRebootTime !== undefined) {
      Timestamp.encode(toTimestamp(message.latestRebootTime), writer.uint32(90).fork()).join();
    }
    if (message.shouldRobotRestart !== false) {
      writer.uint32(96).bool(message.shouldRobotRestart);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Status {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.location = Status_GPSLocation.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.battery = Status_Battery.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.emergencyStopState = Status_EmergencyStopState.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.operationMode = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.availableActions.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.hasArm = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.platformVersion = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.powerPolicy = PowerPolicy.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 90) {
            break;
          }

          message.latestRebootTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 96) {
            break;
          }

          message.shouldRobotRestart = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Status {
    return {
      location: isSet(object.location) ? Status_GPSLocation.fromJSON(object.location) : undefined,
      battery: isSet(object.battery) ? Status_Battery.fromJSON(object.battery) : undefined,
      emergencyStopState: isSet(object.emergencyStopState)
        ? Status_EmergencyStopState.fromJSON(object.emergencyStopState)
        : undefined,
      operationMode: isSet(object.operationMode) ? status_OperationModeFromJSON(object.operationMode) : 0,
      availableActions: globalThis.Array.isArray(object?.availableActions)
        ? object.availableActions.map((e: any) => globalThis.String(e))
        : [],
      hasArm: isSet(object.hasArm) ? globalThis.Boolean(object.hasArm) : false,
      platformVersion: isSet(object.platformVersion) ? globalThis.String(object.platformVersion) : "",
      powerPolicy: isSet(object.powerPolicy) ? PowerPolicy.fromJSON(object.powerPolicy) : undefined,
      latestRebootTime: isSet(object.latestRebootTime) ? fromJsonTimestamp(object.latestRebootTime) : undefined,
      shouldRobotRestart: isSet(object.shouldRobotRestart) ? globalThis.Boolean(object.shouldRobotRestart) : false,
    };
  },

  toJSON(message: Status): unknown {
    const obj: any = {};
    if (message.location !== undefined) {
      obj.location = Status_GPSLocation.toJSON(message.location);
    }
    if (message.battery !== undefined) {
      obj.battery = Status_Battery.toJSON(message.battery);
    }
    if (message.emergencyStopState !== undefined) {
      obj.emergencyStopState = Status_EmergencyStopState.toJSON(message.emergencyStopState);
    }
    if (message.operationMode !== 0) {
      obj.operationMode = status_OperationModeToJSON(message.operationMode);
    }
    if (message.availableActions?.length) {
      obj.availableActions = message.availableActions;
    }
    if (message.hasArm !== false) {
      obj.hasArm = message.hasArm;
    }
    if (message.platformVersion !== "") {
      obj.platformVersion = message.platformVersion;
    }
    if (message.powerPolicy !== undefined) {
      obj.powerPolicy = PowerPolicy.toJSON(message.powerPolicy);
    }
    if (message.latestRebootTime !== undefined) {
      obj.latestRebootTime = message.latestRebootTime.toISOString();
    }
    if (message.shouldRobotRestart !== false) {
      obj.shouldRobotRestart = message.shouldRobotRestart;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Status>, I>>(base?: I): Status {
    return Status.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Status>, I>>(object: I): Status {
    const message = createBaseStatus();
    message.location = (object.location !== undefined && object.location !== null)
      ? Status_GPSLocation.fromPartial(object.location)
      : undefined;
    message.battery = (object.battery !== undefined && object.battery !== null)
      ? Status_Battery.fromPartial(object.battery)
      : undefined;
    message.emergencyStopState = (object.emergencyStopState !== undefined && object.emergencyStopState !== null)
      ? Status_EmergencyStopState.fromPartial(object.emergencyStopState)
      : undefined;
    message.operationMode = object.operationMode ?? 0;
    message.availableActions = object.availableActions?.map((e) => e) || [];
    message.hasArm = object.hasArm ?? false;
    message.platformVersion = object.platformVersion ?? "";
    message.powerPolicy = (object.powerPolicy !== undefined && object.powerPolicy !== null)
      ? PowerPolicy.fromPartial(object.powerPolicy)
      : undefined;
    message.latestRebootTime = object.latestRebootTime ?? undefined;
    message.shouldRobotRestart = object.shouldRobotRestart ?? false;
    return message;
  },
};

function createBaseStatus_GPSLocation(): Status_GPSLocation {
  return { latitude: 0, longitude: 0, altitude: 0 };
}

export const Status_GPSLocation: MessageFns<Status_GPSLocation> = {
  encode(message: Status_GPSLocation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latitude !== 0) {
      writer.uint32(9).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    if (message.altitude !== 0) {
      writer.uint32(25).double(message.altitude);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Status_GPSLocation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatus_GPSLocation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.altitude = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Status_GPSLocation {
    return {
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : 0,
    };
  },

  toJSON(message: Status_GPSLocation): unknown {
    const obj: any = {};
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.altitude !== 0) {
      obj.altitude = message.altitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Status_GPSLocation>, I>>(base?: I): Status_GPSLocation {
    return Status_GPSLocation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Status_GPSLocation>, I>>(object: I): Status_GPSLocation {
    const message = createBaseStatus_GPSLocation();
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.altitude = object.altitude ?? 0;
    return message;
  },
};

function createBaseStatus_Battery(): Status_Battery {
  return { chargePercentage: 0, remainingRuntime: undefined, status: 0 };
}

export const Status_Battery: MessageFns<Status_Battery> = {
  encode(message: Status_Battery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chargePercentage !== 0) {
      writer.uint32(13).float(message.chargePercentage);
    }
    if (message.remainingRuntime !== undefined) {
      Duration.encode(message.remainingRuntime, writer.uint32(18).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Status_Battery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatus_Battery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.chargePercentage = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.remainingRuntime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Status_Battery {
    return {
      chargePercentage: isSet(object.chargePercentage) ? globalThis.Number(object.chargePercentage) : 0,
      remainingRuntime: isSet(object.remainingRuntime) ? Duration.fromJSON(object.remainingRuntime) : undefined,
      status: isSet(object.status) ? status_Battery_StatusFromJSON(object.status) : 0,
    };
  },

  toJSON(message: Status_Battery): unknown {
    const obj: any = {};
    if (message.chargePercentage !== 0) {
      obj.chargePercentage = message.chargePercentage;
    }
    if (message.remainingRuntime !== undefined) {
      obj.remainingRuntime = Duration.toJSON(message.remainingRuntime);
    }
    if (message.status !== 0) {
      obj.status = status_Battery_StatusToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Status_Battery>, I>>(base?: I): Status_Battery {
    return Status_Battery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Status_Battery>, I>>(object: I): Status_Battery {
    const message = createBaseStatus_Battery();
    message.chargePercentage = object.chargePercentage ?? 0;
    message.remainingRuntime = (object.remainingRuntime !== undefined && object.remainingRuntime !== null)
      ? Duration.fromPartial(object.remainingRuntime)
      : undefined;
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseStatus_EmergencyStopState(): Status_EmergencyStopState {
  return { hardwareStopped: false, softwareStopped: false, payloadStoppped: false };
}

export const Status_EmergencyStopState: MessageFns<Status_EmergencyStopState> = {
  encode(message: Status_EmergencyStopState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hardwareStopped !== false) {
      writer.uint32(8).bool(message.hardwareStopped);
    }
    if (message.softwareStopped !== false) {
      writer.uint32(16).bool(message.softwareStopped);
    }
    if (message.payloadStoppped !== false) {
      writer.uint32(24).bool(message.payloadStoppped);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Status_EmergencyStopState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatus_EmergencyStopState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hardwareStopped = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.softwareStopped = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.payloadStoppped = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Status_EmergencyStopState {
    return {
      hardwareStopped: isSet(object.hardwareStopped) ? globalThis.Boolean(object.hardwareStopped) : false,
      softwareStopped: isSet(object.softwareStopped) ? globalThis.Boolean(object.softwareStopped) : false,
      payloadStoppped: isSet(object.payloadStoppped) ? globalThis.Boolean(object.payloadStoppped) : false,
    };
  },

  toJSON(message: Status_EmergencyStopState): unknown {
    const obj: any = {};
    if (message.hardwareStopped !== false) {
      obj.hardwareStopped = message.hardwareStopped;
    }
    if (message.softwareStopped !== false) {
      obj.softwareStopped = message.softwareStopped;
    }
    if (message.payloadStoppped !== false) {
      obj.payloadStoppped = message.payloadStoppped;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Status_EmergencyStopState>, I>>(base?: I): Status_EmergencyStopState {
    return Status_EmergencyStopState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Status_EmergencyStopState>, I>>(object: I): Status_EmergencyStopState {
    const message = createBaseStatus_EmergencyStopState();
    message.hardwareStopped = object.hardwareStopped ?? false;
    message.softwareStopped = object.softwareStopped ?? false;
    message.payloadStoppped = object.payloadStoppped ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
